import { CategoryRepository } from "../../../../data/repository/category/CategoryRepository";
import { StoreRepository } from "../../../../data/repository/store/StoreRepository";
import { Category } from "../../../model/Category";
import { ResponseState, State } from "../../../model/ResponseState";
import { Store } from "../../../model/Store";

export interface GetStoreUseCase {
  invoke: (id: string) => Promise<ResponseState<Store>>;
}

export class GetStoreUseCaseImpl implements GetStoreUseCase {
  private repo: StoreRepository;

  constructor(repo: StoreRepository) {
    this.repo = repo;
  }

  async invoke(id: string): Promise<ResponseState<Store>> {
    try {
      let response = await this.repo.getStore(id);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
